import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./duonut.css";
import { useDispatch } from "react-redux";

import ImageSlider from "./imageSlider";
import Edit from "../../assets/icons/edit";
import { Like } from "../../assets/icons/like";
import See from "../../assets/icons/see";
import { Share } from "../../assets/icons/share";
import { Download } from "../../assets/icons/download";
import { RightArrow } from "../../assets/icons/rightArrow";
import useOutsideAlerter from "../../hooks/useOutsideAlerter";
import { getNumberSuffix } from "../../utils";
import useWindowDimensions from "../../hooks/useWindowDimensions";

import GlobeIcon from "../../assets/icons/myduonut/globe.svg";
import HeartIcon from "../../assets/icons/myduonut/heart.svg";
import PlayCircle from "../../assets/icons/myduonut/play-circle.svg";
import VerticalBars from "../../assets/icons/myduonut/vertical-bars.svg";
import WriteIcon from "../../assets/icons/myduonut/write.svg";
import { selectUserActivity } from "../../redux/slices/userActivity";
import { deleteDuonut, getMyDuonuts } from "../../services/duonut";
import { updateDeleteDuonutConfirmModal } from "../../redux/slices/formDetails";

var mL = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
var mS = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];

const Duonut = ({ name, duonut_category_id, duonutthumbnail_set, created_at, isFiltered, id: duonutId, isMyDuonuts, thumbnail }) => {
  const [showOptions, setShowOptions] = useState(false);
  const [popUpPositionX, setPopUpPositionX] = useState(null);
  const [popUpPositionY, setPopUpPositionY] = useState(null);

  const date = new Date(created_at);
  const { width } = useWindowDimensions();
  duonutthumbnail_set = thumbnail === null ? duonutthumbnail_set : [{ id: 2, thumbnail }, ...duonutthumbnail_set];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [previousIndex, setPreviousIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const popUpHandler = (e) => {
    setShowOptions(!showOptions);
    let pos = menuIconRef.current.getBoundingClientRect();
    let offsetLeft = menuIconRef.current.offsetLeft;

    if (isFiltered) {
      setPopUpPositionX(offsetLeft + 13);
      setPopUpPositionY(menuIconRef.current.offsetTop);
      //if exceeds window width
      if (offsetLeft + 13 + 250 > width) {
        setPopUpPositionX(offsetLeft - 205);
      }
    } else {
      setPopUpPositionX(pos.left + 13);
      //if exceeds window width
      if (pos.left + 13 + 250 > width) {
        setPopUpPositionX(pos.left - 205);
      }
      setPopUpPositionY(menuIconRef.current.offsetTop);
    }
  };

  // to close duonut options menu
  const optionsRef = useRef(null);
  const menuIconRef = useRef(null);
  const handleClose = () => setShowOptions(false);
  useOutsideAlerter(optionsRef, handleClose);

  let timeInterval = useRef(null);

  //change thumbnails
  let intervalId;

  const changeThumbnails = (playing) => setIsPlaying(true);

  useEffect(() => {
    if (isPlaying === false) return;
    intervalId = setInterval(() => {
      // console.log(currentIndex)
      if (currentIndex === duonutthumbnail_set.length - 1) {
        setCurrentIndex(0);
      } else {
        setCurrentIndex((prevIndex) => prevIndex + 1);
      }
    }, 2000);
    return () => clearInterval(intervalId);
  }, [isPlaying, currentIndex]);

  const resetThumbnails = () => {
    clearInterval(intervalId);
    setIsPlaying(false);
    setCurrentIndex(0);
  };

  const handleEdit = () => {
    // getDuonut(duonutId, (err, res) => {
    //    if (err) return console.log(err)
    //    let mastersData = []
    //    // console.log(mastersData)
    //    for (const [key, value] of Object.entries(res.data.masters_data)) {
    //       if (value.length >= 1) {
    //          mastersData.push(...value)
    //       }
    //    }
    //    mastersData = mastersData.sort((a, b) => (a.priority > b.priority) ? 1 : -1)
    //    console.log(res.data)

    //    let settings = {
    //       title: res.data.name,
    //       description: res.data.description,
    //       isPublic: !res.data.private,
    //       isPrivate: res.data.private,
    //       category: res.data.duonut_category_id.id
    //    }
    //    localStorage.removeItem('userActivities')
    //    dispatch(updateSettings({ settings }))
    //    dispatch(updateDuonutToEdit({ duonutToEdit:  res.data }))
    //    dispatch(updateIsEditing({ isEditing: true }))
    //    dispatch(updateDuonutThumbnailSet({ thumbnails: res.data.duonutthumbnail_set }))
    //    dispatch(setUserActivity({ activities: mastersData, defaultActivities: mastersData }))
    //    navigate('/design')
    // })
    dispatch(selectUserActivity(0));
    navigate(`/design/${duonutId}`);
    // window.location.reload()
  };

  useEffect(() => {
    if (duonutthumbnail_set.length === 1) return;
    if (isPlaying === false) return clearInterval(timeInterval.current);

    if (currentIndex === 0) {
      setPreviousIndex(duonutthumbnail_set.length - 1);
    } else {
      setPreviousIndex(currentIndex - 1);
    }
    return () => clearInterval(timeInterval.current);
  }, [currentIndex]);

  /* DELETE method */

  const handelDelete = () => {
    dispatch(
      updateDeleteDuonutConfirmModal({
        active: true,
        duonutId,
      })
    );
  };

  return (
    <div className="duonut" onMouseEnter={() => changeThumbnails(true)} onMouseLeave={resetThumbnails}>
      <div className="top">
        <div className="left">
          <img src={GlobeIcon} style={{ cursor: "pointer", marginRight: "6.66px" }} />
          <img src={HeartIcon} style={{ cursor: "pointer" }} />
        </div>
        <div className="right">
          <img src={HeartIcon} style={{ cursor: "pointer", marginRight: "6.5px" }} />
          <img src={WriteIcon} style={{ cursor: "pointer" }} />
          <div style={{ display: "flex", alignItems: "center" }} onClick={(e) => popUpHandler(e)} ref={menuIconRef}>
            <img
              src={VerticalBars}
              style={{
                cursor: "pointer",
                padding: "2px 6px",
                paddingLeft: "8px",
              }}
            />
          </div>
        </div>
      </div>
      <div className="img">
        {duonutthumbnail_set.length >= 1 ? (
          <ImageSlider duonutthumbnail_set={duonutthumbnail_set} currentIndex={currentIndex} previousIndex={previousIndex} isPlaying={isPlaying} />
        ) : (
          <img src="/assets/theme.png" alt="" />
        )}
      </div>
      <div className="bottom">
        <div className="left">
          <div className="activityName">{name}</div>
          <div className="totalActivities">N Activites</div>
          <div className="interactions" style={{ width: "100%" }}>
            <div
              className="like"
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <Like className="icon" />
              <span>20</span>
            </div>
            <div
              className="see"
              style={{
                display: "flex",
                alignItems: "center",
                marginLeft: "10.83px",
                cursor: "pointer",
              }}
            >
              <See className="icon" />
              <span style={{ marginLeft: "6.77px" }}>240</span>
            </div>
            <div
              className="share"
              style={{
                display: "flex",
                alignItems: "center",
                marginLeft: "10.49px",
                cursor: "pointer",
              }}
            >
              <Share className="icon" />
              <span style={{ marginLeft: "6.43px" }}>12</span>
            </div>
            <div
              className="download"
              style={{
                display: "flex",
                alignItems: "center",
                marginLeft: "11px",
                cursor: "pointer",
              }}
            >
              <Download className="icon" />
              <span style={{ marginLeft: "6.94px" }}>3</span>
            </div>
          </div>
        </div>
        <div className="button"> {duonut_category_id.name} </div>
      </div>
      {showOptions && (
        <div
          ref={optionsRef}
          className="options"
          style={
            // popUpPositionX < 1350 ?
            { top: `${popUpPositionY}px`, left: `${popUpPositionX}px` }
            //: { top: `${popUpPositionY + 260}px`, left: `${popUpPositionX - 280}px` }
          }
        >
          <div className="top">
            <div className="popuptitle">{name}</div>
            <span>{`created on ${getNumberSuffix(date.getDate())} ${mS[date.getMonth()]} ${date.getFullYear()}`}</span>
          </div>
          <div className="mainpopup">
            <ul>
              {isMyDuonuts && (
                <li className="item" onClick={handleEdit}>
                  <span>Edit</span>
                </li>
              )}
              <li className="item">
                <span>View as a user</span>
              </li>
              <li className="item" onClick={() => navigate(`/pdf/${duonutId}`)}>
                <span style={{ marginRight: "17px" }}>Download</span>
                <RightArrow />
              </li>
              <li className="item">
                <span>Share</span>
              </li>
              {isMyDuonuts && (
                <li className="item" onClick={handelDelete}>
                  <span>Delete</span>
                </li>
              )}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default Duonut;
